function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.39995 0L8.59995 0.006C9.26595 0.006 9.79995 0.534 9.79995 1.2V10.8C9.79995 11.466 9.26595 12 8.59995 12H1.39995C0.733951 12 0.199951 11.466 0.199951 10.8V1.2C0.199951 0.534 0.733951 0 1.39995 0ZM1.39992 10.8H8.59992V1.2H1.39392L1.39992 10.8ZM2.59995 1.8C2.26858 1.8 1.99995 2.06863 1.99995 2.4C1.99995 2.73137 2.26858 3 2.59995 3C2.93132 3 3.19995 2.73137 3.19995 2.4C3.19995 2.06863 2.93132 1.8 2.59995 1.8ZM3.79995 2.4C3.79995 2.06863 4.06858 1.8 4.39995 1.8C4.73132 1.8 4.99995 2.06863 4.99995 2.4C4.99995 2.73137 4.73132 3 4.39995 3C4.06858 3 3.79995 2.73137 3.79995 2.4ZM4.99995 10.2C6.65595 10.2 7.99995 8.856 7.99995 7.2C7.99995 5.544 6.65595 4.2 4.99995 4.2C3.34395 4.2 1.99995 5.544 1.99995 7.2C1.99995 8.856 3.34395 10.2 4.99995 10.2ZM6.41599 8.616C7.19599 7.836 7.19599 6.564 6.41599 5.784L3.58399 8.616C4.36399 9.396 5.63599 9.396 6.41599 8.616Z",
  fill: "#121221"
});

function SvgLaundryTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundryTiny);
export default __webpack_public_path__ + "static/media/LaundryTiny.df223a7f.svg";
export { ForwardRef as ReactComponent };